// Admin activation metrics: complete, dedicated seven-locale copy.
// This namespace is deliberately kept separate from public/product copy.
export const ADMIN_ANALYTICS_OVERLAY = {
  en: { adminAnalytics: {
    title: "Product Analytics",
    subtitle: "Registered → First match → 5 matches → 10 matches · Database totals, not Google Play installs",
    since: "New users since",
    refresh: "Refresh",
    registered: "Registered",
    withOne: "With 1+ match",
    withFive: "With 5+ matches",
    withTen: "With 10+ matches",
    without: "Without a match",
    rate: "Activation rate",
    funnel: "Activation funnel · All-time",
    first: "First match",
    five: "5+ matches",
    ten: "10+ matches",
    sinceCount: "Registrations since {{date}}",
    ofThese: "Of these, with a match",
    newRate: "New-user activation",
    loading: "Loading product analytics…",
    error: "Could not load analytics. Verify that the admin metrics migration has been applied.",
    empty: "No analytics available.",
    note: "{{count}} saved matches across registered, non-anonymous accounts. 5+/10+ means total matches logged, not recurring active users. Dates use Greece local midnight; new-user activation means they have logged at least one match at any time. Test and review accounts are included."
  }},
  el: { adminAnalytics: {
    title: "Ανάλυση χρήσης",
    subtitle: "Εγγραφή → Πρώτος αγώνας → 5 αγώνες → 10 αγώνες · Στοιχεία βάσης, όχι εγκαταστάσεις Google Play",
    since: "Νέοι χρήστες από",
    refresh: "Ανανέωση",
    registered: "Εγγεγραμμένοι",
    withOne: "Με 1+ αγώνα",
    withFive: "Με 5+ αγώνες",
    withTen: "Με 10+ αγώνες",
    without: "Χωρίς αγώνα",
    rate: "Ποσοστό ενεργοποίησης",
    funnel: "Διαδρομή ενεργοποίησης · Συνολικά",
    first: "Πρώτος αγώνας",
    five: "5+ αγώνες",
    ten: "10+ αγώνες",
    sinceCount: "Εγγραφές από {{date}}",
    ofThese: "Από αυτούς, με αγώνα",
    newRate: "Ενεργοποίηση νέων χρηστών",
    loading: "Φόρτωση στοιχείων χρήσης…",
    error: "Δεν ήταν δυνατή η φόρτωση των στοιχείων. Έλεγξε ότι έχει εφαρμοστεί η migration των admin metrics.",
    empty: "Δεν υπάρχουν διαθέσιμα στοιχεία χρήσης.",
    note: "{{count}} αποθηκευμένοι αγώνες από εγγεγραμμένους, μη ανώνυμους λογαριασμούς. Οι 5+/10+ αγώνες δείχνουν συνολικές καταχωρίσεις, όχι συστηματικά ενεργούς χρήστες. Οι ημερομηνίες ξεκινούν τα μεσάνυχτα Ελλάδας· ενεργοποίηση νέου χρήστη σημαίνει ότι έχει καταχωρίσει τουλάχιστον έναν αγώνα οποτεδήποτε. Περιλαμβάνονται δοκιμαστικοί λογαριασμοί."
  }},
  es: { adminAnalytics: {
    title: "Análisis de uso",
    subtitle: "Registro → Primer partido → 5 partidos → 10 partidos · Datos de la base, no instalaciones de Google Play",
    since: "Nuevos usuarios desde",
    refresh: "Actualizar",
    registered: "Registrados",
    withOne: "Con 1+ partido",
    withFive: "Con 5+ partidos",
    withTen: "Con 10+ partidos",
    without: "Sin partidos",
    rate: "Tasa de activación",
    funnel: "Embudo de activación · Histórico",
    first: "Primer partido",
    five: "5+ partidos",
    ten: "10+ partidos",
    sinceCount: "Registros desde {{date}}",
    ofThese: "De ellos, con un partido",
    newRate: "Activación de nuevos usuarios",
    loading: "Cargando estadísticas de uso…",
    error: "No se pudieron cargar los datos. Comprueba que se haya aplicado la migración de métricas de administración.",
    empty: "No hay datos disponibles.",
    note: "{{count}} partidos guardados por cuentas registradas no anónimas. 5+/10+ indica partidos registrados en total, no usuarios activos habituales. Las fechas empiezan a medianoche en Grecia; activación significa que el usuario ha registrado al menos un partido en cualquier momento. Se incluyen cuentas de prueba."
  }},
  fr: { adminAnalytics: {
    title: "Analyse d’utilisation",
    subtitle: "Inscription → Premier match → 5 matchs → 10 matchs · Données de la base, pas les installations Google Play",
    since: "Nouveaux utilisateurs depuis",
    refresh: "Actualiser",
    registered: "Inscrits",
    withOne: "Avec 1+ match",
    withFive: "Avec 5+ matchs",
    withTen: "Avec 10+ matchs",
    without: "Sans match",
    rate: "Taux d’activation",
    funnel: "Parcours d’activation · Total",
    first: "Premier match",
    five: "5+ matchs",
    ten: "10+ matchs",
    sinceCount: "Inscriptions depuis le {{date}}",
    ofThese: "Parmi eux, avec un match",
    newRate: "Activation des nouveaux inscrits",
    loading: "Chargement des statistiques d’utilisation…",
    error: "Impossible de charger les données. Vérifiez que la migration des statistiques admin a été appliquée.",
    empty: "Aucune donnée disponible.",
    note: "{{count}} matchs enregistrés par des comptes inscrits non anonymes. 5+/10+ indique le nombre total de matchs saisis, pas les utilisateurs actifs réguliers. Les dates commencent à minuit en Grèce ; l’activation indique au moins un match enregistré à tout moment. Les comptes de test sont inclus."
  }},
  de: { adminAnalytics: {
    title: "Nutzungsanalyse",
    subtitle: "Registrierung → Erstes Match → 5 Matches → 10 Matches · Datenbankwerte, keine Google-Play-Installationen",
    since: "Neue Nutzer seit",
    refresh: "Aktualisieren",
    registered: "Registriert",
    withOne: "Mit 1+ Match",
    withFive: "Mit 5+ Matches",
    withTen: "Mit 10+ Matches",
    without: "Ohne Match",
    rate: "Aktivierungsrate",
    funnel: "Aktivierungstrichter · Gesamt",
    first: "Erstes Match",
    five: "5+ Matches",
    ten: "10+ Matches",
    sinceCount: "Registrierungen seit {{date}}",
    ofThese: "Davon mit Match",
    newRate: "Aktivierung neuer Nutzer",
    loading: "Nutzungsdaten werden geladen…",
    error: "Nutzungsdaten konnten nicht geladen werden. Prüfe, ob die Admin-Metriken-Migration angewendet wurde.",
    empty: "Keine Nutzungsdaten verfügbar.",
    note: "{{count}} gespeicherte Matches aus registrierten, nicht anonymen Konten. 5+/10+ bedeutet insgesamt erfasste Matches, nicht regelmäßig aktive Nutzer. Datumsgrenzen gelten ab Mitternacht in Griechenland; aktiviert heißt, dass irgendwann mindestens ein Match erfasst wurde. Testkonten sind enthalten."
  }},
  it: { adminAnalytics: {
    title: "Analisi dell’utilizzo",
    subtitle: "Registrazione → Prima partita → 5 partite → 10 partite · Dati del database, non installazioni Google Play",
    since: "Nuovi utenti dal",
    refresh: "Aggiorna",
    registered: "Registrati",
    withOne: "Con 1+ partita",
    withFive: "Con 5+ partite",
    withTen: "Con 10+ partite",
    without: "Senza partite",
    rate: "Tasso di attivazione",
    funnel: "Percorso di attivazione · Totale",
    first: "Prima partita",
    five: "5+ partite",
    ten: "10+ partite",
    sinceCount: "Registrazioni dal {{date}}",
    ofThese: "Di questi, con una partita",
    newRate: "Attivazione nuovi utenti",
    loading: "Caricamento analisi dell’utilizzo…",
    error: "Impossibile caricare i dati. Verifica che sia stata applicata la migrazione delle metriche admin.",
    empty: "Nessun dato disponibile.",
    note: "{{count}} partite salvate da account registrati non anonimi. 5+/10+ indica le partite registrate in totale, non gli utenti attivi regolarmente. Le date partono dalla mezzanotte greca; l’attivazione richiede almeno una partita registrata in qualsiasi momento. Sono inclusi gli account di test."
  }},
  ja: { adminAnalytics: {
    title: "利用状況の分析",
    subtitle: "登録 → 初回試合 → 5試合 → 10試合 · Google Playのインストール数ではなくデータベースの集計",
    since: "新規登録の開始日",
    refresh: "更新",
    registered: "登録ユーザー",
    withOne: "1試合以上",
    withFive: "5試合以上",
    withTen: "10試合以上",
    without: "試合記録なし",
    rate: "利用開始率",
    funnel: "利用開始までの推移 · 累計",
    first: "初回試合",
    five: "5試合以上",
    ten: "10試合以上",
    sinceCount: "{{date}}以降の登録",
    ofThese: "うち試合記録あり",
    newRate: "新規ユーザーの利用開始率",
    loading: "利用状況を読み込み中…",
    error: "利用状況を読み込めませんでした。管理者向け集計のマイグレーションが適用済みか確認してください。",
    empty: "利用状況データがありません。",
    note: "登録済みの非匿名アカウントによる保存済み試合は{{count}}件です。5試合以上・10試合以上は累計記録数であり、継続利用者数ではありません。日付はギリシャ時間の午前0時を基準とし、新規ユーザーの利用開始は、いつでも1試合以上を記録したことを意味します。テスト用アカウントも含まれます。"
  }}
} as const;

export type AdminAnalyticsKey = keyof typeof ADMIN_ANALYTICS_OVERLAY.en.adminAnalytics;
